import DateRangePicker from "@mostrans/web-components/components/advanced/DateRangePicker";
import { getPreDefinedDateRange } from "@mostrans/web-components/helpers/dateHelpers";
import Icon from "@mui/material/Icon";
import React, { useEffect, useMemo, useState } from "react";
import { useGlobalFilter } from "../../shared/hooks/useGlobalFilter";

function FilterStartEndDate() {
    const { globalFilter, setFilter, filter } = useGlobalFilter();

    const date = useMemo(() => {
        return getPreDefinedDateRange();
    }, []);

    const [shouldMount, setShouldMount] = useState(true);

    useEffect(() => {
        setShouldMount(false);
    }, [globalFilter.startDate, globalFilter.endDate]);
    useEffect(() => {
        if (!shouldMount) setShouldMount(true);
    }, [shouldMount]);

    return shouldMount ? (
        <DateRangePicker
            initialSettings={{
                ranges: date,
                startDate: globalFilter.startDate,
                endDate: globalFilter.endDate,
            }}
            onCallback={(start, end) => {
                setFilter({
                    ...filter,
                    startDate: start,
                    endDate: end,
                });
            }}
            startIcon={<Icon>calendar_today</Icon>}
        />
    ) : (
        <React.Fragment />
    );
}

export default FilterStartEndDate;
